import { createNullableProvideInject } from '@collector/shared-ui'

import { ImportantStats } from '../configuration'

export const [provideImportantStatsId, injectImportantStatsId] =
  createNullableProvideInject<ImportantStats>('importantStatsId')
